<template>
  <div class="c-flex-c">
    <v-layout align-center class="c-flex-00a crx-toolbar subheading">
      <v-btn
      @click="$emit('onClose')" 
      text icon>
        <v-icon color="color1">mdi-arrow-left</v-icon>
      </v-btn>
      <div class="c-flex-r1 align-center text-sans font-weight-bold">
        History
      </div>
      <v-spacer></v-spacer>

      <v-text-field
      v-model="searchText"
      solo
      prepend-inner-icon="search"
      placeholder="Search"
      color="text"
      hide-details
      clearable>
      </v-text-field>

      <v-layout align-center pl-2 pr-2 shrink>
        <span class="caption">
          <v-menu offset-y
          :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
              >
                <span >{{ ((page - 1) * rowsPerPage) + 1 }}-{{ Math.min(page * rowsPerPage, searchMatches.length) }} of {{ searchMatches.length }}</span>
              </v-btn>
            </template>
            <v-card class="pa-2">
              <span class="caption">Items per page</span>
              <v-text-field
              v-model="rowsPerPageTV"
              hide-details
              style="max-width: 70px;"
              solo></v-text-field>
            </v-card>
          </v-menu>
        </span>
        <v-btn
        text
        icon
        class="ma-0"
        color="blue"
        :disabled="page <= 1"
        @click="page--">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-btn
        text
        icon
        color="blue"
        class="ma-0"
        :disabled="page >= paginationLength"
        @click="page++">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-layout>
    </v-layout>
    <!-- MAIN CONTENT -->
    <div style="overflow: auto; height: 100%;">
      <div style="display: table;">
        <div style="display: table-row;" class="unselectable">
          <div class="hcell">
            <span @click="clickSortHeader(0)" class="sort-button">
              Batch
              <v-icon 
              small
              color="color1"
              :class="['sort-arrow', {'rotate': sortIndex === 0 && sortAscending}, {'visible': sortIndex === 0 }]">
                arrow_downward
              </v-icon>
            </span>
          </div>
          <div class="hcell">
            <span @click="clickSortHeader(1)" class="sort-button">
              Inventory
              <v-icon 
              small
              color="color1"
              :class="['sort-arrow', {'rotate': sortIndex === 1 && sortAscending}, {'visible': sortIndex === 1 }]">
                arrow_downward
              </v-icon>
            </span>
          </div>
          <div class="hcell">
            <span @click="clickSortHeader(2)" class="sort-button">
              Entry
              <v-icon 
              small
              color="color1"
              :class="['sort-arrow', {'rotate': sortIndex === 2 && sortAscending}, {'visible': sortIndex === 2 }]">
                arrow_downward
              </v-icon>
            </span>
          </div>
          <div class="hcell">
            <span @click="clickSortHeader(3)" class="sort-button">
              Expiry
              <v-icon 
              small
              color="color1"
              :class="['sort-arrow', {'rotate': sortIndex === 3 && sortAscending}, {'visible': sortIndex === 3 }]">
                arrow_downward
              </v-icon>
            </span>
          </div>
          <div class="hcell">
            <span @click="clickSortHeader(4)" class="sort-button">
              Supplier
              <v-icon 
              small
              color="color1"
              :class="['sort-arrow', {'rotate': sortIndex === 4 && sortAscending}, {'visible': sortIndex === 4 }]">
                arrow_downward
              </v-icon>
            </span>
          </div>
        </div>

        <div style="display: table-row; background: #f8f8f8;">
          <div class="hcell">
            <v-text-field
            v-model="searchText"
            solo
            prepend-inner-icon="search"
            placeholder="Search"
            color="text"
            hide-details
            clearable>
            </v-text-field>
          </div>
          <div class="hcell">
          </div>
          <div class="hcell">
          </div>
          <div class="hcell">
          </div>
          <div class="hcell">
          </div>
        </div>

        <history-row
        v-for="item in paginatedArray" 
        :key="item.tempID"
        :item="item"
        @click.native="clickRow(item)"
        @returnToInventory="returnToInventory">
        </history-row>
      </div>
      <div class="text-xs-center">
        <v-pagination
        v-if="paginationLength > 1"
        v-model="page"
        :length="paginationLength"
        circle>

        </v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ListController from '@/mixins/ListController'
import HistoryRow from './history-row'

export default {
  props: ['id'],
  mixins: [ListController],
  components: {
    HistoryRow
  },
  data () {
    return {

    }
  },
  computed: {
    itemsSource () {
      return Object.values(this.$store.state.db.inventoryArchive.archive).filter(item => item.inventory_item_id === parseInt(this.id))
    }
  },
  methods: {
    clickRow (item) {

    },
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // id
        return items.sort((a, b) => {
          return sortAscending ? a.id - b.id : b.id - a.id
        })
      } else if (headerIndex === 1) { // Inventory
        return items.sort((a, b) => {
          return sortAscending ? a.inventory - b.inventory : b.inventory - a.inventory
        })
      } else if (headerIndex === 2) { // Date of entry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.date_of_entry) - new Date(a.date_of_entry) : new Date(a.date_of_entry) - new Date(b.date_of_entry)
        })
      } else if (headerIndex === 3) { // Expiry
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } else if (headerIndex === 4) { // Supplier
        return items.sort((a, b) => {
          var supplierA = (this.$store.state.db.suppliers.suppliers[a.supplier_id] || {}).name || ''
          var supplierB = (this.$store.state.db.suppliers.suppliers[b.supplier_id] || {}).name || ''
          return sortAscending ? supplierA.localeCompare(supplierB) : supplierB.localeCompare(supplierA)
        })
      }
    },
    returnToInventory (item) {
      return new Promise((resolve, reject) => {
        let data = {
          archive_id: item.id,
          inventory_item_id: item.inventory_item_id
        }
        this.$axios.post('inventory/return-archive-item',
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            alert('Successful')
            resolve()
          })
          .catch(error => {
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    }
  },
  mounted () {
    this.items = JSON.parse(JSON.stringify(this.itemsSource))
    this.items.forEach(item => {
      var inventory = Object.values(this.$store.state.db.inventory.inventory).filter(invItem => invItem.archive_id === item.id)
      item.inventory = inventory.reduce((a, i) => a + i.quantity, 0)
    })
  }
}
</script>

<style scoped lang="scss">
.hcell {
  display: table-cell;
  width: 20%;
  overflow: hidden;
  border-bottom: 1px solid #dadce0;
  border-right: 1px solid #dadce0;
  color: #5f6368;
  font: 400 12px/16px Roboto,Arial,Helvetica,sans-serif;
  font-weight: 500;
  /* height: 32px; */
  letter-spacing: .3px;
  padding: 8px 12px 8px 16px;
  &:last-child {
    border-right: none;
  }
  & .sort-button {
    cursor: pointer;
  }
}
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>

